/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

/**
 * Base class for our config loaders.
 */
class AbstractConfigLoader {
  _values!: { [key: string]: any };

  /**
   * Classes are expected to override this method.
   */
  async init(): Promise<void> {
    throw new Error('init must be overridden for specific loader');
  }

  isEmpty(): boolean {
    return !this._values || Object.keys(this._values).length === 0;
  }

  getValue(key: string): any {
    return this._values[key];
  }
}

export default AbstractConfigLoader;
